import moment from "moment";

import { DateRangePicker } from "../../react/utils/dateRangePicker/DateRangePicker";

import template from "./pOvertimes.html";

export function pOvertimesDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pOvertimesController,
    controllerAs: 'pOvertimes',
    bindToController: true
  };

  return directive;
}

class pOvertimesController {
  constructor ($filter, Auth, DownloadFile, Notes, Stats, Work, ConnectionQuality, $translate, $scope, $rootScope, $window, $interval, $location, $q) {
    'ngInject';

    this.$filter = $filter;
    this.Auth = Auth;
    this.Notes = Notes;
    this.DownloadFile = DownloadFile;
    this.Stats = Stats;
    this.Work = Work;
    this.ConnectionQuality = ConnectionQuality;
    this.$translate = $translate;
    this.showModal = false;
    this.overtimeUserModal = "";
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.allUsersSelected = true;
    this.$interval = $interval;
    this.$location = $location;
    this.$q = $q;

    this.DateRangePicker = DateRangePicker;

    this.$scope.$watch(() =>  this.$rootScope.reloadOvertime , () => this.updateView());
    this.$scope.$watch(() =>  this.$rootScope.reloadAnnualSettle , () => this.updateView());

    this.viewType = this.$location.path().includes('/management') ? 'management' : 'team';

    this.headersOvertime = [
      {
        id: "date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.DATE"),
        name: this.$translate.instant("OVERTIME.DATE"),
        class: "table-info"
      },
      {
        id: "worknorm",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.WORKNORM"),
        name: this.$translate.instant("OVERTIME.WORKNORM"),
        class: "table-info worknorm"
      },
      {
        id: "type",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.WORK_TYPE"),
        name: this.$translate.instant("OVERTIME.TYPE"),
        class: "table-info"
      },
      {
        id: "workTime",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.WORK_TIME"),
        name: this.$translate.instant("OVERTIME.WORK_TIME"),
        class: "table-info"
      },
      {name: null, class: "table-160"},
      {
        id: "reported",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.REPORTED_OVERTIME"),
        name: this.$translate.instant("OVERTIME.REPORTED"),
        class: "table-info"
      },
      {
        id: "accepted",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.ACCEPTED_OVERTIME"),
        name: this.$translate.instant("OVERTIME.ACCEPT"),
        class: "table-info"
      },
      {
        id: "comment",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.COMMENT"),
        name: this.$translate.instant("OVERTIME.COMMENT"),
        class: "table-info"
      },
      {id: "acceptAll", name: null, class: "table-mode"}
    ];

    this.preferencesDictionary = {
      managementLevel: "Management",
      teamLeaderLevel: "TeamLeader",
      deputyTeamLeaderLevel: "DeputyTeamLeader",
      employeeLevel: "Employee"
    };

    this.filteredHeadersOvertime = this.headersOvertime.filter(h => h.id !== "acceptAll");

    this.state = "loading";
    this.isFirstRun = true;
    this.wasSavingInterrupted = sessionStorage.getItem('roedl-overtimes-interrupted');

    if (localStorage.getItem('roedl-dark-background')) {
      document.querySelector('body').classList.add('darkerBackground');
    }

    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {this.$interval.cancel(timeout);});

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        if (this.viewType === 'management')
          this.$q.all([this.Stats.getSubordinateTeams(), this.Work.getViewLevelSettings()]).then(
            (success) => {
              this.subTeams = success[0].data
                .filter(sub =>
                  this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' ? sub.id !== '49a6dcff-c4e6-443e-9627-597070a68c8e' : true
                ).sort((a, b) => a.name.localeCompare(b.name));
              this.noViewLevelSettings = success[1].status === 204;

              if (this.noViewLevelSettings) {
                this.managementMode = true;
                this.managementLevel = true;
                this.state = 'loaded';
              } else {
                this.setPreferencesInfo(success[1].data);
                this.init();
              }
            }, (res) => {
              this.state = "error";
              this.error = res;
              this.Notes.postNote({
                type: "error",
                message: res.data
              });
            }
          );
        else
          this.init();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    this.$scope.$on("$locationChangeStart", (event) => {
      if (!this.summaryOvertime)
        return;

      const isSomeSaving = Object
        .keys(this.summaryOvertime)
        .filter(userId =>
          this.summaryOvertime[userId] &&
          this.summaryOvertime[userId].overtimes_T &&
          this.summaryOvertime[userId].overtimes_T.some(overtime => overtime.saving)
        ).length > 0;
      if (isSomeSaving && !confirm('Some changes are still saving, do you want to exit?')) {
        event.preventDefault();
        return;
      }

      sessionStorage.setItem('roedl-overtimes-interrupted', true);
    });

    $window.onbeforeunload = (event) => {
      event.stopPropagation();
      const isSomeSaving = Object
        .keys(this.summaryOvertime)
        .filter(userId =>
          this.summaryOvertime[userId] &&
          this.summaryOvertime[userId].overtimes_T &&
          this.summaryOvertime[userId].overtimes_T.some(overtime => overtime.saving)
        ).length > 0;
      if (isSomeSaving) {
        $window.onbeforeunload = undefined;
        return '';
      }
    };
  }

  setPreferencesInfo(data) {
    Object.entries(this.preferencesDictionary).forEach(([key, value]) => {
      if (data.viewLevels.includes(value))
        this[key] = true;
    });
    this.employeeLevelTeam = data.teamId;
  }

  init() {
    let dateStartInStorage = sessionStorage.getItem("roedl-tl-date-start");
    let dateEndInStorage = sessionStorage.getItem("roedl-tl-date-end");

    if(dateStartInStorage){
      this.dateStartChoice = dateStartInStorage;
      this.dateEndChoice = dateEndInStorage;
    }

    // this.Stats.getWorklogs(this.dateStartChoice, this.dateEndChoice);
    if (this.wasSavingInterrupted) {
      this.state = 'loading';
      this.refreshOvertime(null, 'update');
      sessionStorage.setItem('roedl-overtimes-interrupted', false);
      this.wasSavingInterrupted = false;
    } else
      this.refreshOvertime();

    this.acceptanceHierarchyFlag = this.user.preferences.featureFlags.some(ff => ff === "AcceptanceHierarchy");
    this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");

    if (this.overtimeApplicationsFlag) {
      this.filteredHeadersOvertime.splice(
        5,
        0,
        {
          id: "applicationOvertime",
          name: this.$translate.instant("OVERTIME.APPLICATION_OVERTIME"),
          class: "table-info application-overtime",
          tooltip: this.$translate.instant("STATS.TOOLTIP.APPLICATION_OVERTIME")
        },
        {
          id: "allocatedApplicationOvertime",
          name: this.$translate.instant("OVERTIME.ALLOCATED_APPLICATION_OVERTIME"),
          class: "table-info",
          tooltip: this.$translate.instant("STATS.TOOLTIP.ALLOCATED_APPLICATION_OVERTIME")
        }
      );
    }
  }

  isManagementViewType() {
    return this.viewType === 'management';
  }

  getMoreData() {
    this.state = "loading";
    this.viewToggledOut = false;

    this.refreshOvertime();
  }

  updateView(){
    if(this.$rootScope.reloadOvertime === true || this.$rootScope.reloadAnnualSettle === true){
      this.$rootScope.reloadOvertime = false;
      this.$rootScope.reloadAnnualSettle = false;
      this.stateLoadingBalance = "loading";
      this.refreshOvertime(null, 'update');
    }
  }

  updateDates(values) {
    this.dateStart = moment(values[0]);
    this.dateEnd = moment(values[1]);

    this.dateStartChoice = this.dateStart.format("YYYY-MM-DD");
    this.dateEndChoice = this.dateEnd.format("YYYY-MM-DD");

    this.viewToggledOut = moment.duration(this.dateEnd.diff(this.dateStart)).asDays() > 9;

    //save date to session storage
    sessionStorage.setItem("roedl-tl-date-start" , this.dateStartChoice);
    sessionStorage.setItem("roedl-tl-date-end" , this.dateEndChoice);

    // this.Stats.getWorklogs(this.dateStartChoice, this.dateEndChoice);

    if (!this.viewToggledOut) {
      this.getMoreData();
    }
  }

  filterUsers() {
    this.filtersOpen = !this.filtersOpen;
    this.allUsersSelected = this.summary.users.every(u => u.visible);
  }

  selectAllUsers() {
    this.summary.users.forEach(u => u.visible = this.allUsersSelected);
    const data = this.summary.users.map( u => ({name: u.name, id: u.id , visible: u.visible}));
    this.Stats.changeTeamLeaderGlobalPreferences(this.isManagementViewType() ? "mvOvertimeSelectedUsers" : "tlvOvertimeSelectedUsers", data)
    .then(()=>{
      if (this.isManagementViewType())
        this.user.preferences.mvOvertimeSelectedUsers = data;
      else
        this.user.preferences.tlvOvertimeSelectedUsers = data;
      }
    ).catch(
      res => this.Notes.postNote({
        type: "success",
        message: res.data
      })
    );
  }

  deselectUser() { // run on change of any filter-user checkbox
    if (this.allUsersSelected && this.summary.users.find(u => u.visible != true)) {
      this.allUsersSelected = false;
    }

    if (!this.allUsersSelected && this.summary.users.every(u => u.visible == true)) {
      this.allUsersSelected = true;
    }
    const data = this.summary.users.map( u => ({name: u.name, id: u.id , visible: u.visible}));
    this.Stats.changeTeamLeaderGlobalPreferences(this.isManagementViewType() ? "mvOvertimeSelectedUsers" : "tlvOvertimeSelectedUsers", data)
    .then(()=>{
      if (this.isManagementViewType())
        this.user.preferences.mvOvertimeSelectedUsers = data;
      else
        this.user.preferences.tlvOvertimeSelectedUsers = data;
     }
    ).catch(
      res => this.Notes.postNote({
        type: "success",
        message: res.data
      })
    );
  }

  exportData() {
    this.state = "loading";
    var users = this.summary.users.filter((x) => x.visible).map((x) => x.id);
    return this.Stats.exportOvertimes(this.dateStartChoice, this.dateEndChoice, users, this.isManagementViewType() ? true : false).then((success) => {
      this.state = "loaded";
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `klix-${this.dateStartChoice}-${this.dateEndChoice}-${moment().format("HH:mm")}.xlsx`
        );
    }, (error) => {
      this.error = error;
      this.state = 'error';
    });
  }

  deserializeData(usersWithEntries) {
    const filteredUsers = this.isManagementViewType()
      ? this.user.preferences.mvOvertimeSelectedUsers || []
      : this.user.preferences.tlvOvertimeSelectedUsers || [];

    var users = usersWithEntries.map( userWithEntries => {
      const filteredUserVisibility = filteredUsers && filteredUsers.find(user => user.id == userWithEntries.user.id);

      return {
        name: userWithEntries.user.fullName,
        id: userWithEntries.user.id,
        visible: filteredUsers &&  filteredUserVisibility ? filteredUserVisibility.visible : true,
        isInCurrentTeam: userWithEntries.isInCurrentTeam,
        isBlocked: userWithEntries.user.blockedAt && moment().isSameOrAfter(userWithEntries.user.blockedAt),
        teamId: userWithEntries.workdayTimes[0] ? userWithEntries.workdayTimes[0].teamId : userWithEntries.user.teamId
      };
    });
    users.sort((a,b) => a.name.localeCompare(b.name));
    var summary = {
      date: moment(this.dateStartChoice).format("YYYY-MM-DD")+ " — " +moment(this.dateEndChoice).format("YYYY-MM-DD"),
      users: users
    };
    this.allUsersSelected = summary.users.every(u => u.visible);
    return summary;
  }

  refreshOvertime(overtime, update) {
    const getOvertimesRequest = this.isManagementViewType()
      ? this.Stats.getOvertimesForManager(this.dateStartChoice, this.dateEndChoice, update)
      : this.Stats.getOvertimes(this.dateStartChoice, this.dateEndChoice, update);
    getOvertimesRequest.then(
      (success) => {
        let isDateInSessionStorage = sessionStorage.getItem("roedl-tl-date-start");

        if (overtime) {
          overtime.saving = false;
          const overtimeSummaries = this.isManagementViewType()
            ? success.data.overtimeSummaries.map(summary => summary.userOvertimeSummaries).flat()
            : success.data.overtimeSummaries;
          const updatedOvertimeWithWorkday = overtimeSummaries.find(summaries => summaries.user.id == overtime.userId);
          const summaryOvertime = this.summaryOvertime[overtime.userId + overtime.teamId];
          const updatedOvertime = updatedOvertimeWithWorkday.workdayTimes.find(workday => {
            if (window.DD_LOGS && (!workday || !workday.date)) {
              window.DD_LOGS.error("DD HANDLER - workday.date is undefined", {workday});
            }

            if (window.DD_LOGS && (!overtime || !overtime.date)) {
              window.DD_LOGS.error("DD HANDLER - overtime.date is undefined", {overtime});
            }

            return workday.date == overtime.date && workday.reportedOvertime == overtime.reportedOvertime;
        });

          summaryOvertime.overtimes.forEach(previousOvertime => {
            this.updateOvertime(previousOvertime, updatedOvertime);
          });
          summaryOvertime.overtimes_T.forEach(previousOvertime => this.updateOvertime(previousOvertime, updatedOvertime));

          summaryOvertime.isUndertime = moment.duration(updatedOvertimeWithWorkday.cumulatedOvertime) < 0;
          summaryOvertime.totalCumulatedOvertime = this.$filter("hms")(updatedOvertimeWithWorkday.cumulatedOvertime);
          summaryOvertime.acceptedBalanceFromPreviousYears = updatedOvertimeWithWorkday.acceptedBalanceFromPreviousYears;
          summaryOvertime.totalAcceptedOvertime = this.$filter("hms")(this.sumOfOvertimeValue("acceptedOvertime", overtime.userId + overtime.teamId));
          summaryOvertime.totalReportedOvertime = this.$filter("hms")(this.sumOfOvertimeValue("reportedOvertime", overtime.userId + overtime.teamId));
          summaryOvertime.cumulatedApplicationOvertime = this.$filter("hms")(updatedOvertimeWithWorkday.cumulatedApplicationOvertime);
          summaryOvertime.totalApplicationOvertime = this.$filter("hms")(this.sumOfOvertimeValue("applicationOvertime", overtime.userId + overtime.teamId));
          summaryOvertime.totalAllocatedOvertimeRequest = this.$filter("hms")(this.sumOfOvertimeValue("allocatedApplicationOvertime", overtime.userId + overtime.teamId));
          summaryOvertime.settledApplicationOvertime  = updatedOvertimeWithWorkday.settledApplicationOvertime;
          summaryOvertime.acceptedApplicationBalanceFromPreviousYears = updatedOvertimeWithWorkday.acceptedApplicationBalanceFromPreviousYears;
        }

        if(this.isFirstRun){
          if(!isDateInSessionStorage){
            this.dateStartChoice = moment(success.data.from).format("YYYY-MM-DD");
            this.dateEndChoice = moment(success.data.to).format("YYYY-MM-DD");
            sessionStorage.setItem("roedl-tl-date-start" , this.dateStartChoice);
            sessionStorage.setItem("roedl-tl-date-end" , this.dateEndChoice);
          }
          this.dateRangePickerProps = {
            defaultValue: [new Date(this.dateStartChoice), new Date(this.dateEndChoice)],
            onChange: (values) => this.updateDates(values)
          };
          this.isFirstRun = false;
        }

        this.state = "loaded";
        this.stateLoadingBalance = "loaded";

        if (!overtime)
          this.overtimeTableMaker(success.data);
      },
      (error) => {
        this.state = "error";
        this.stateOvertime = "error";
        this.error = error;
      }
    );
  }

  updateOvertime(previousOvertime, updatedOvertime) {
    if (window.DD_LOGS && (!previousOvertime || !previousOvertime.date)) {
      window.DD_LOGS.error("DD HANDLER - previousOvertime.date is undefined", {previousOvertime});
    }

    if (window.DD_LOGS && (!updatedOvertime || !updatedOvertime.date)) {
      window.DD_LOGS.error("DD HANDLER - updatedOvertime.date is undefined", {updatedOvertime});
    }

    if (previousOvertime.date == updatedOvertime.date && previousOvertime.reportedOvertime == updatedOvertime.reportedOvertime) {
      previousOvertime = Object.assign(previousOvertime, updatedOvertime);

      Object.keys(previousOvertime).map(key => {
        switch (key) {
          case 'accepted':
            previousOvertime.accepted = previousOvertime.isAccepted || previousOvertime.acceptedOvertime == previousOvertime.reportedOvertime;
            break;
          case 'undertime':
            previousOvertime.undertime = moment.duration(previousOvertime.reportedOvertime) < 0;
            break;
          case 'noOvertime':
            previousOvertime.noOvertime = moment.duration(previousOvertime.reportedOvertime) == 0;
            break;
          case 'edited':
            previousOvertime.edited = previousOvertime.canUpdateOvertime && !previousOvertime.noOvertime && !previousOvertime.accepted;
            previousOvertime.durationText = this.$filter("hms")(previousOvertime.reportedOvertime);
            break;
          case 'comment':
            previousOvertime.comment = previousOvertime.overtimeAcceptComment;
            break;
          default:
            return;
        }
      });
    }
  }

  sumOfOvertimeValue(value, key) {
    let overtimes = this.summaryOvertime[key].overtimes.map(o => o[value]);
    let sumOfovertimesInMiliseconds = 0;
    if(overtimes.length>0){
      sumOfovertimesInMiliseconds = overtimes.reduce((sum , curr) => moment.duration(sum)+ moment.duration(curr));
    }
    return moment.duration(sumOfovertimesInMiliseconds).toJSON();
  }

  overtimeTableMaker( data ) {
    let overtimeSummaries = this.isManagementViewType()
      ? data.overtimeSummaries.map(summary => summary.userOvertimeSummaries).flat()
      : data.overtimeSummaries;
    overtimeSummaries = overtimeSummaries.filter(userWithEntries => this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' ? userWithEntries.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' : true);
    this.summary = this.deserializeData(overtimeSummaries);
    this.cannotAcceptMyself = this.acceptanceHierarchyFlag && !data.canAcceptOwnEntries;

    this.summaryOvertime = {};
    overtimeSummaries.map( userOvertime => {
      userOvertime.workdayTimes.map( o => {
          o.accepted = o.isAccepted || o.acceptedOvertime == o.reportedOvertime;
          o.undertime = moment.duration(o.reportedOvertime) < 0;
          o.noOvertime = moment.duration(o.reportedOvertime) == 0;
          o.edited = o.canUpdateOvertime && !o.noOvertime && !o.accepted;
          o.comment = o.overtimeAcceptComment;
          if(o.edited) o.durationText = this.$filter("hms")(o.reportedOvertime);
      });

      if (window.DD_LOGS && (!userOvertime || !userOvertime.workdayTimes || userOvertime.workdayTimes.some(o => !o.date))) {
        const workdayTime = userOvertime.workdayTimes.find(o => !o.date);
        window.DD_LOGS.error("DD HANDLER - workdayTime.date is undefined", {workdayTime});
      }

      this.summaryOvertime[userOvertime.user.id + (userOvertime.workdayTimes[0] ? userOvertime.workdayTimes[0].teamId : userOvertime.user.teamId)] = {
        name: userOvertime.user.fullName,
        isUndertime: moment.duration(userOvertime.cumulatedOvertime) < 0,
        totalCumulatedOvertime: this.$filter("hms")(userOvertime.cumulatedOvertime),
        acceptedBalanceFromPreviousYears: userOvertime.acceptedBalanceFromPreviousYears,
        overtimes: userOvertime.workdayTimes.sort((a,b)=> new Date(a.date) - new Date(b.date)),
        cumulatedApplicationOvertime: this.$filter("hms")(userOvertime.cumulatedApplicationOvertime),
        allocatedApplicationOvertime: userOvertime.allocatedApplicationOvertime,
        settledApplicationOvertime: this.$filter("hms")(userOvertime.settledApplicationOvertime),
        acceptedApplicationBalanceFromPreviousYears: this.$filter("hms")(userOvertime.acceptedApplicationBalanceFromPreviousYears)
      };
    });
    this.LongTermLeaveIdList = [];

    Object.keys(this.summaryOvertime).forEach( key => {
      const overtimesAcceptedWithoutZero = this.summaryOvertime[key].overtimes.filter(overtime => moment.duration(overtime.reportedOvertime) !== 0 && overtime.accepted).length;
      const allOvertimes = this.summaryOvertime[key].overtimes.length;
      const overtimesWithoutZero = this.summaryOvertime[key].overtimes.filter(overtime => moment.duration(overtime.reportedOvertime) !== 0).length;
      const LongTermLeave = this.summaryOvertime[key].overtimes.filter(overtime => {
          return overtime.expectedWorknorm.positionType === "LongTermLeave";
      }).length;

      if(LongTermLeave === allOvertimes && allOvertimes!== 0) {
        this.LongTermLeaveIdList.push(key);
      }

      this.summaryOvertime[key].allAcceptedOvertimes = overtimesAcceptedWithoutZero === overtimesWithoutZero;

      this.summaryOvertime[key].totalAcceptedOvertime = this.$filter("hms")(this.sumOfOvertimeValue("acceptedOvertime", key));
      this.summaryOvertime[key].totalReportedOvertime = this.$filter("hms")(this.sumOfOvertimeValue("reportedOvertime", key));
      this.summaryOvertime[key].totalApplicationOvertime = this.$filter("hms")(this.sumOfOvertimeValue("applicationOvertime", key));
      this.summaryOvertime[key].totalAllocatedOvertimeRequest = this.$filter("hms")(this.sumOfOvertimeValue("allocatedApplicationOvertime", key));
    });
    let usersOnLongTermLeave = this.summary.users.filter( user => {
      return this.LongTermLeaveIdList.indexOf(user.id) >= 0;
    });
    this.summary.users = this.summary.users.filter( user => {
      return this.LongTermLeaveIdList.indexOf(user.id) < 0;
    }).concat(usersOnLongTermLeave);
  }

  acceptOvertimeStart(originalOvertime) {
    originalOvertime.saving = true;
    originalOvertime.error = false;
    let duration = (moment.duration(originalOvertime.reportedOvertime) < 0) ? "PT0H" : originalOvertime.reportedOvertime;
    
    if (window.DD_LOGS && (!originalOvertime || !originalOvertime.date)) {
      window.DD_LOGS.error("DD HANDLER - originalOvertime.date is undefined", {originalOvertime});
    }

    let overtime = {
      userId: originalOvertime.userId,
      date: originalOvertime.date,
      duration: duration,
      comment: originalOvertime.comment
    };
    const editOvertimeRequest = this.isManagementViewType()
      ? this.Stats.editOvertimeAsManager(overtime)
      : this.Stats.editOvertime(overtime);
    return editOvertimeRequest.then(
      () => {
        return Promise.resolve();
      },
      (res) => {
        this.state = "error";

        if (res.status !== 403)
          originalOvertime.error = true;
        else
          this.Notes.postNote({
            type: "error",
            message: res.data.message
          });

        return Promise.reject();
      }
    );
  }

  acceptOvertime(originalOvertime) {
    originalOvertime.saving = true;
    this.acceptOvertimeStart(originalOvertime).then(() => {
      this.refreshOvertime(originalOvertime, 'update');
    });
  }

  acceptAllOvertimesRecurency(items) {
    if(!items.length) {
      this.refreshOvertime(null, 'update');
      return Promise.resolve();
    }
    const first = items[0];
    const rest = items.slice(1);
    this.acceptOvertimeStart(first).then(
      () => {
        this.acceptAllOvertimesRecurency(rest);
      },
      () => {
        this.refreshOvertime(null, 'update');
      }
    );
  }

  acceptAllOvertime(user) {
    const items = this.summaryOvertime[user.id + user.teamId].overtimes
    .filter((x) => (!x.edited || !x.saving) && moment.duration(x.reportedOvertime) != 0 && moment.duration(x.acceptedOvertime) == 0 );

    items.map(overtime => overtime.saving = true);
    this.acceptAllOvertimesRecurency(items);
  }

  editOvertimeStart(originalOvertime) {
    originalOvertime.edited = true;
    originalOvertime.error = false;
    originalOvertime.durationText = this.$filter("hms")(originalOvertime.acceptedOvertime);
    originalOvertime.newDuration = originalOvertime.acceptedOvertime;
  }

  checkOvertime(overtime){
    return overtime.durationText === this.$filter("hms")("PT0H");
  }

  editOvertimeSave(originalOvertime) {
    originalOvertime.saving = true;
    originalOvertime.error = false;

    if (window.DD_LOGS && (!originalOvertime || !originalOvertime.date)) {
      window.DD_LOGS.error("DD HANDLER - originalOvertime.date is undefined editOvertimeSave", {originalOvertime});
    }

    let overtime = {
      userId: originalOvertime.userId,
      date: originalOvertime.date,
      duration: originalOvertime.newDuration,
      comment: originalOvertime.comment
    };

    if(originalOvertime.newDuration === undefined){
      overtime = {
        userId: originalOvertime.userId,
        date: originalOvertime.date,
        duration: originalOvertime.reportedOvertime,
        comment: originalOvertime.comment
      };
    }

    if(overtime.duration) {
      const editOvertimeRequest = this.isManagementViewType()
        ? this.Stats.editOvertimeAsManager(overtime)
        : this.Stats.editOvertime(overtime);

      editOvertimeRequest.then(
        () => {
          this.refreshOvertime(originalOvertime, 'update');
        },
        (res) => {
          this.state = "error";
          originalOvertime.saving = false;

          if (res.status !== 403)
            originalOvertime.error = true;
          else
            this.Notes.postNote({
              type: "error",
              message: res.data.message
            });
        }
      );
    } else {
      this.editOvertimeCancel(originalOvertime);
      originalOvertime.saving = false;
      this.state = "loaded";
    }
  }

  editOvertimeDecline(overtime) {
    overtime.saving = true;
    overtime.error = false;

    if (window.DD_LOGS && (!overtime || !overtime.date)) {
      window.DD_LOGS.error("DD HANDLER - overtime.date is undefined", {overtime});
    }

    let overtimeDeclined = {
      userId: overtime.userId,
      date: overtime.date,
      duration: moment.duration(this.$filter("hms")("PT0H")),
      comment: overtime.comment,
      saving: overtime.saving
    };

    const editOvertimeRequest = this.isManagementViewType()
      ? this.Stats.editOvertimeAsManager(overtimeDeclined)
      : this.Stats.editOvertime(overtimeDeclined);

      return editOvertimeRequest.then(
      () => {
        return Promise.resolve();
      },
      (res) => {
        this.state = "error";

        if (res.status !== 403)
          overtimeDeclined.error = true;
        else
          this.Notes.postNote({
            type: "error",
            message: res.data.message
          });

        return Promise.reject();
      }
    ).then( () => {
      this.refreshOvertime(overtime, 'update');
    });
  }

  editOvertimeCancel(overtime) {
    delete overtime.newDuration;
    delete overtime.durationInvalid;
    delete overtime.durationText;
    overtime.comment = overtime.overtimeAcceptComment;
    overtime.edited = false;
    overtime.error = false;
  }

  updateDuration(overtime) {
    var format = /\d+:\d\d:\d\d/;
    var match = overtime.durationText.match(format);
    const previousDuration = overtime.reportedOvertime && moment.duration(overtime.reportedOvertime);
    const previousDurationMatch = overtime.reportedOvertime && this.$filter("hms")(overtime.reportedOvertime).match(format);
    const isPreviousDurationMatchSameAsNewMatch = match && previousDurationMatch && match[0] == previousDurationMatch[0];
    if(match && match.length == 1) {
      const newDuration = moment.duration(match[0]);
      // handle miliseconds precision when no duration change
      overtime.newDuration = isPreviousDurationMatchSameAsNewMatch && previousDuration || newDuration;
      overtime.durationInvalid = false;
    } else {
      overtime.newDuration = undefined;
      overtime.durationInvalid = true;
    }
  }

  translateNorm(label){
    if(label === "Hourly"){
      return this.$translate.instant("POSITION.HOURLYNORM");
    }
    if(label === "Worknorm"){
      return this.$translate.instant("POSITION.WORKNORM");
    }
    if(label === "LongTermLeave"){
      return this.$translate.instant("POSITION.LONGTERMLEAVE");
    }
    return label;
  }

  openShareModal(user){
    this.overtimeUserModal = user;
    this.showModal = true;
  }

  openSettleModal(user){
    this.overtimeUserModal = user;
    this.showSettleModal = true;
  }

  closeShareModal(){
    this.showModal = false;
  }

  exportWorklogs(userId, date) {
    this.state = "loading";
    return this.Stats.export(date, date, this.viewType, userId).then((success) => {
      this.state = "loaded";
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `klix-${date}-${moment().format("HH:mm")}.xlsx`
      );
    }, (error) => {
      this.error = error;
      this.state = 'error';
    });
  }

  showData() {
    this.state = "loading";

    const data = {
      viewLevels: []
    };

    Object.keys(this.preferencesDictionary).forEach(key => {
      if (this[key])
        data.viewLevels.push(this.preferencesDictionary[key]);
    });

    if (this.employeeLevel) {
      data.teamId = this.employeeLevelTeam;
    }

    this.Work.editViewLevelSettings(data).then(
      (success) => {
        this.managementMode = false;
        this.setPreferencesInfo(success.data);

        if (this.noViewLevelSettings) {
          this.noViewLevelSettings = false;
          this.init();
        } else
          this.refreshOvertime(null, "update");
      },
      (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      }
    );
  }

  extrasForName(subTeam) {
    const extraValues = [];
    if (subTeam.excludeFromProfitabilityReport)
      extraValues.push(`${this.$translate.instant("WORK_DATA.DISPLAY_PREFERENCES.EXCLUDED_FROM_PROFITABILITY_VIEW")}`);
    
    if (subTeam.archivedAt)
      extraValues.push(`(${this.$translate.instant("TEAMS.ARCHIVED")})`);

    return extraValues.join(" ");
  }
}
